import React, { useState } from "react";
import "../styles/ProductCardFilter.css";

function ProductCardFilter({ data, apiFilter, setApiFilter }) {
  const filter = data;
  const [expandedFilters, setExpandedFilters] = useState({});
  const [filterItems, setFilterItems] = useState([]) || "Nothing to Filter";
  const toggleFilter = (index) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handleFilters = (val) => {
    setFilterItems((prev) => {
      if (!prev.includes(val)) {
        const updatedItems = [...prev, val];
        setApiFilter(updatedItems);
        return updatedItems;
      } else {
        const updatedItems = prev.filter((item) => item !== val);
        setApiFilter(updatedItems);
        return updatedItems;
      }
    });
  };
  const removeItems = (item) => {
    setFilterItems((prev) => {
      const updatedItems = prev.filter((product) => product !== item);
      setApiFilter(updatedItems);
      return updatedItems;
    });
  };

  return (
    <div>
      <div className="mt-1">
        <p className="font-rubik">Filters</p>
        {filterItems?.map((item) => (
          <div key={item}>
            <div className="  bg-[#f2f2f2] flex justify-between border-2 items-center  mt-3">
              <div className="text-[#787a7c]">{item}</div>
              <i
                className="fa-solid fa-xmark text-[13px] mr-1 cursor-pointer "
                onClick={() => removeItems(item)}
              ></i>
            </div>
          </div>
        ))}
      </div>

      {filter?.filters?.map((item, index) => (
        <div key={index} className="border-pink-900 cursor-pointer">
          <div
            className="flex justify-between mt-2"
            onClick={() => toggleFilter(index)}
          >
            <div> {item.name} </div>
            <div className="flex items-center mr-3">
              <i
                className={`fa-solid ${
                  expandedFilters[index] ? "fa-minus" : "fa-plus"
                }`}
              ></i>
            </div>
          </div>
          {expandedFilters[index] && (
            <div>
              {Object.entries(item.values).map(([value, count]) => (
                <div key={value} className="mt-1 flex items-center  ">
                  <input
                    type="checkbox"
                    name="checkBox"
                    id={`${item.name}-${value}`}
                    className="cursor-pointer ml-2  outline-none  "
                    onChange={() => handleFilters(value.split(":")[0])}
                    checked={filterItems.includes(value.split(":")[0])}
                    style={{ border: "2px solid #1a73e8" }}
                  />
                  <label
                    htmlFor={`${item.name}-${value}`}
                    className="cursor-pointer flex items-center ml-2"
                  >
                    {item.name === "Color" ? (
                      <div
                        className="h-[15px] w-[15px]"
                        style={{ backgroundColor: `#${value.split("#")[1]}` }}
                      ></div>
                    ) : (
                      ""
                    )}
                    <span>{value.split(":")[0]}</span>
                  </label>
                  <div className="text-[13px] mt-[-20px] text-gray-400">
                    {count}
                  </div>
                </div>
              ))}
            </div>
          )}
          <hr />
        </div>
      ))}
    </div>
  );
}
export default ProductCardFilter;
